// extracted by mini-css-extract-plugin
export default {"deleteModal":"styles_deleteModal__fSv5s","content":"styles_content__SQ+v3","body":"styles_body__z4-uX","promptTxt":"styles_promptTxt__vHYp4","promptBtn":"styles_promptBtn__MhcDH"};